import { render, staticRenderFns } from "./Accesory.vue?vue&type=template&id=56e24995&"
import script from "./Accesory.vue?vue&type=script&lang=js&"
export * from "./Accesory.vue?vue&type=script&lang=js&"
import style0 from "./Accesory.vue?vue&type=style&index=0&id=56e24995&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports